import axios from "axios";
import { serverUrl } from "../../components/Helpers/Config";
import { GET_VIDEOS_GALLERY,GET_VIDEOS_LOADING } from ".";

export const getVideosGallery = () => {
    return (dispatch) => {
         dispatch({ type: GET_VIDEOS_LOADING, payload: true })
        axios.get(`${serverUrl.GetVideos}`)
            .then(response => {
                if (response.status === 200) {
                    if (response.data) {
                        const videos = response.data;
                        dispatch({ type: GET_VIDEOS_GALLERY, videos })
                         dispatch({ type: GET_VIDEOS_LOADING, payload: false })
                    }
                } else {
                }
            }).catch(err => {
                console.log(err)
                 dispatch({ type: GET_VIDEOS_LOADING, payload: false })
                // dispatch({ type: GET_VIDEOS_GALLERY, payload: false })
            })
    }
}
